import { formControlFactory } from "../../lib/formControlFactory";
import * as Components from "./components";
import { validatePhoneNumber } from "./validation";
export const PhoneNumber = formControlFactory({
    emptyValue: "",
    component: Components.InternalPhoneNumberView,
    propMapping: (props) => {
        const rules = {
            ...(props.rules ?? {}),
        };
        if (props.rules?.required) {
            rules.validate = {
                ...rules.validate,
                phone: validatePhoneNumber,
            };
        }
        return { ...props, rules };
    },
});
PhoneNumber.displayName = "PhoneNumber";
export default PhoneNumber;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGhvbmVOdW1iZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9QaG9uZU51bWJlci9QaG9uZU51bWJlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFDbEUsT0FBTyxLQUFLLFVBQVUsTUFBTSxjQUFjLENBQUM7QUFDM0MsT0FBTyxFQUFFLG1CQUFtQixFQUFFLE1BQU0sY0FBYyxDQUFDO0FBRW5ELE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxrQkFBa0IsQ0FBQztJQUM1QyxVQUFVLEVBQUUsRUFBRTtJQUNkLFNBQVMsRUFBRSxVQUFVLENBQUMsdUJBQXVCO0lBQzdDLFdBQVcsRUFBRSxDQUFDLEtBQUssRUFBRSxFQUFFO1FBQ3JCLE1BQU0sS0FBSyxHQUFHO1lBQ1osR0FBRyxDQUFDLEtBQUssQ0FBQyxLQUFLLElBQUksRUFBRSxDQUFDO1NBQ3ZCLENBQUM7UUFFRixJQUFJLEtBQUssQ0FBQyxLQUFLLEVBQUUsUUFBUSxFQUFFLENBQUM7WUFDMUIsS0FBSyxDQUFDLFFBQVEsR0FBRztnQkFDZixHQUFHLEtBQUssQ0FBQyxRQUFRO2dCQUNqQixLQUFLLEVBQUUsbUJBQW1CO2FBQzNCLENBQUM7UUFDSixDQUFDO1FBRUQsT0FBTyxFQUFFLEdBQUcsS0FBSyxFQUFFLEtBQUssRUFBRSxDQUFDO0lBQzdCLENBQUM7Q0FDRixDQUFDLENBQUM7QUFFSCxXQUFXLENBQUMsV0FBVyxHQUFHLGFBQWEsQ0FBQztBQUV4QyxlQUFlLFdBQVcsQ0FBQyJ9